import { useRef } from 'react';
import { ScrollButton } from './ScrollButton';
import { useTabManager } from '../hooks/useTabManager';
import { TabNavContainer, ScrollableTabNav } from './styled';
export function TabNav(props) {
    const { children, scrollLeftButtonLabel, scrollRightButtonLabel, className } = props;
    const { tabGroupId } = useTabManager();
    const ref = useRef(null);
    const scroll = (distance) => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: distance, behavior: 'smooth' });
    };
    return (<TabNavContainer role="tablist" id={tabGroupId} className={className}>
      {scrollLeftButtonLabel && (<ScrollButton direction="left" onClick={() => scroll(-100)} label={scrollLeftButtonLabel}/>)}
      <ScrollableTabNav ref={ref}>{children}</ScrollableTabNav>
      {scrollRightButtonLabel && (<ScrollButton direction="right" onClick={() => scroll(100)} label={scrollRightButtonLabel}/>)}
    </TabNavContainer>);
}
